export default {
  common: {
    attention: 'Attention',
    error: 'Erreur',
    success: 'Succès',
    continue: 'Continuer',
    understood: 'COMPRIS !',
    backToLogin: 'Retour à la connexion',
    please: 'Veuillez :',
  },
  login: {
    password: 'Mot de passe',
    cpf: 'CPF',
    email: 'E-mail',
    loginWith: 'Se connecter avec :',
    logWith: 'Se connecter avec :',
    forgotPassword: 'Mot de passe oublié ?',
    noAccount: 'Pas de compte ?',
    noAccountYet: 'Vous n\'avez pas encore de compte ?',
    switchToEmail: 'Basculer vers l\'e-mail',
    switchToCpf: 'Basculer vers le CPF',
    register: 'Inscrivez-vous',
    createAccount: 'CRÉER UN COMPTE',
  },
  cadastro: {
    iAgreeWith: "J'accepte les",
    termsOfUse: "Conditions d'utilisation et la politique de confidentialité",
    fromThisSite: 'de ce site.',
    acceptTermsPrivacy:
      "Acceptez les conditions d'utilisation et la politique de confidentialité",
    termsOfUsePrivacy: "Conditions d'utilisation et politique de confidentialité",
    requiredField: 'Obligatoire',
    optinLoadError:
      'Revenez et réessayez, ou contactez le support. La erreur suivante s\'est produite : {error}',
    waitRegisteringYourAccount:
      'Veuillez patienter, nous enregistrons votre compte. Cela peut prendre quelques secondes.',
    accountCreationMessage: 'Inscription effectuée avec succès !',
    accountCreationMessageError: 'Impossible de créer votre compte.',
    accountCreationMessageNetworkError:
      'Erreur réseau : vérifiez votre connexion Internet.',
    requiredTerms: 'Vous devez accepter toutes les conditions obligatoires.',
    requiredTermsTitle: 'Conditions obligatoires',
  },
  cpfVerification: {
    placeholder: 'Entrez votre CPF',
    notInBrazil: 'Je ne vis pas au Brésil',
    cpfEmailAssociated:
      'Votre CPF et votre e-mail sont déjà associés à un compte.<br />Pour continuer, entrez le code de vérification envoyé à l\'e-mail enregistré.',
    verificationCodePlaceholder: 'Entrez le code de vérification reçu',
    cpfRequired: 'Vous devez indiquer votre CPF.',
    cpfInvalid: 'Veuillez entrer un CPF valide.',
  },
  country: {
    label: 'Dans quel pays vivez-vous ?',
    loadError: 'La recherche de la liste des pays a échoué.',
    required: 'Vous devez indiquer le pays.',
  },
  passport: {
    placeholder: 'Passeport',
    required: 'Vous devez indiquer le passeport.',
    invalid: 'Veuillez entrer un passeport valide.',
  },
  birthDate: {
    placeholder: 'Date de naissance (jj/mm/aaaa)',
    required: 'Vous devez indiquer votre date de naissance.',
    invalid: 'Veuillez entrer une date de naissance valide.',
    minimumAge: 'Inscription autorisée uniquement pour les personnes de plus de {age} ans.',
  },
  gender: {
    identity: 'Identité de genre',
    male: 'Masculin',
    female: 'Féminin',
    other: 'Autre',
    required: 'Vous devez indiquer votre genre.',
  },
  name: {
    firstName: 'Prénom',
    fullName: 'Nom complet',
    surname: 'Nom de famille',
    fullNameRequired: 'Vous devez indiquer votre nom complet.',
    firstNameRequired: 'Vous devez indiquer votre prénom.',
    surnameRequired: 'Vous devez indiquer votre nom de famille.',
    socialNameRequired: 'Vous devez indiquer comment vous souhaitez être appelé(e).',
    beCalled: 'Comment souhaitez-vous être appelé(e) ?',
  },
  cpfAndPhone: {
    cpfInvalid: 'Veuillez entrer un CPF valide.',
    phoneRequired: 'Vous devez indiquer un numéro de téléphone.',
    phoneInvalid: 'Veuillez entrer un numéro de téléphone valide.',
    phoneInternationalInvalid: 'Veuillez entrer un numéro de téléphone international valide.',
  },
  email: {
    placeholder: 'E-mail',
    confirmPlaceholder: 'Confirmez votre e-mail',
    verificationCode: 'Entrez le code de vérification reçu',
    required: 'Vous devez indiquer un e-mail.',
    invalid: 'Veuillez entrer un e-mail valide.',
    mismatch: 'Les e-mails indiqués sont différents.',
    codeRequired: 'Vous devez indiquer le code de vérification.',
    codeInvalid: 'Code incorrect.',
  },
  phone: {
    mobile: 'Téléphone portable',
    ddi: 'Indicatif*',
    areaCode: 'Indicatif régional*',
    yourPhone: 'Votre téléphone*',
    required: 'Vous devez indiquer un numéro de téléphone.',
    invalid: 'Veuillez entrer un numéro de téléphone valide.',
  },
  password: {
    password: 'Mot de passe',
    repeatPassword: 'Répéter le mot de passe',
    minimumCharacterPass: 'Au moins 8 caractères.',
    specialCharacter: 'Au moins 1 caractère spécial.',
    oneNumber: 'Au moins 1 chiffre.',
    requiredPass: 'Un mot de passe est requis.',
    minimumCharacterPassError: 'Le mot de passe doit contenir au moins 8 caractères.',
    specialCharacterError: 'Le mot de passe doit contenir au moins 1 caractère spécial.',
    oneNumberError: 'Le mot de passe doit contenir au moins 1 chiffre.',
    differentPass: 'Les mots de passe indiqués sont différents.',
  },
  cep: {
    cep: 'CODE POSTAL',
    city: 'VILLE',
    address: 'ADRESSE',
    neighborhood: 'QUARTIER',
    state: 'ÉTAT',
    stateHint: 'Forme abrégée uniquement (max. 4 caractères)',
    number: 'Nº',
    complement: 'COMPLÉMENT',
    cepRequired: 'Vous devez indiquer un code postal.',
    numberRequired: 'Vous devez indiquer un numéro.',
    onlyNumber: 'Le Nº ne doit contenir que des chiffres.',
    addressRequired: 'Vous devez indiquer la localité et l\'adresse.',
    neighborhoodRequired: 'Vous devez indiquer un quartier.',
    stateRequired: 'Vous devez indiquer un état.',
  },
  guardian: {
    firstName: 'Prénom du responsable',
    surname: 'Nom de famille du responsable',
    cpf: 'CPF du responsable',
    email: 'E-mail du responsable',
    birthDate: 'Date de naissance du responsable',
    phone: 'Téléphone portable du responsable',
    degree: 'Lien de parenté',
    verificationCode: 'Entrez le code de vérification',
    codeSent: 'Un code a été envoyé à l\'e-mail du responsable !',
    firstNameRequired: 'Vous devez indiquer le nom du responsable.',
    surnameRequired: 'Vous devez indiquer le nom de famille.',
    cpfInvalid: 'Veuillez entrer un CPF valide.',
    phoneRequired: 'Vous devez indiquer un numéro de téléphone.',
    phoneInvalid: 'Veuillez entrer un numéro de téléphone valide.',
    genderRequired: 'Vous devez indiquer le genre.',
    degreeRequired: 'Vous devez indiquer le lien de parenté.',
    birthDateInvalid: 'Veuillez entrer une date de naissance valide pour le responsable.',
    ageRequired: 'Le responsable doit être majeur (plus de 18 ans).',
    emailInvalid: 'Un e-mail valide est requis.',
    codeInvalid: 'Code incorrect.',
  },
  searchUser: {
    cpfOrEmail: 'CPF ou E-mail',
    guardianName: 'Nom du responsable',
  },
  gnv: {
    fanTypeTitle: 'ÊTES-VOUS SUPPORTEUR DE L\'ATLÉTICO ?',
    fanTypeDescription:
      'Sélectionnez une option pour continuer votre inscription au Galo ID.',
    fanTypeAtleticano: 'JE SUIS SUPPORTEUR',
    fanTypeVisitante: 'JE NE SUIS PAS SUPPORTEUR',
    benefitsTitle: 'Êtes-vous sûr de vouloir continuer ?',
    benefitsDescription: 'En décochant, vous perdrez l\'accès aux avantages exclusifs :',
    benefitsCta: 'Le plan GNV da Massa est 100% gratuit !',
    benefitsConfirmWithPlan: 'JE VEUX ÊTRE GNV',
    benefitsConfirmWithoutPlan: 'CONTINUER SANS',
    benefits: [
      'Prix exclusifs sur les billets',
      'Accès anticipé aux ventes',
      'Réductions sur les produits officiels',
      'Bonus de pièces sur le Superapp',
      'Cashback sur les achats partenaires',
      'Promotions et tirages au sort exclusifs',
    ],
    under18Title: 'ATTENTION',
    under18Message:
      'Oups ! L\'offre du plan GNV da Massa gratuit est réservée aux personnes de plus de 18 ans. Nous allons poursuivre votre inscription sans attribution du plan.',
  },
  foreignUnder18: {
    title: 'ATTENTION',
    message:
      'L\'inscription des mineurs en tant qu\'étrangers n\'est pas autorisée. Contactez le support à contato@galonaveia.com.br pour plus d\'informations.',
  },
}
